import axios from '@/libs/axios'
import { ApiCode } from '@/const/api'
import { handleCatch } from '@/utils'
import { STATUSES } from '@/const/status'

export default {
  namespaced: true,
  state: {
    departments: [],
    totalRows: 0,
  },
  getters: {
    departments: state => state.departments,
    totalRows: state => state.totalRows,
  },
  mutations: {
    SET_DEPARTMENTS: (state, data) => {
      state.departments = data
    },
    SET_TOTAL_ROWS: (state, data) => {
      state.totalRows = data
    },
  },
  actions: {
    async readDepartments({ commit }, params) {
      try {
        const response = await axios.get('uni/departments', { params })
        const { data } = response
        if (data.code === ApiCode.SUCCESS) {
          const { total, records } = data.data
          commit('SET_TOTAL_ROWS', total)
          commit('SET_DEPARTMENTS', records)
        }
      } catch (e) {
        handleCatch(e)
      }
    },
    async createDepartments({ commit }, params) {
      try {
        const response = await axios.post('uni/departments', params)
        const { data } = response
        return { isSuccessful: data.code === ApiCode.SUCCESS, message: data.message }
      } catch (e) {
        handleCatch(e)
      }
      return null
    },
    async updateDepartments({ commit }, params) {
      try {
        const response = await axios.put(`uni/departments/${params.id}`, params)
        const { data } = response
        return { isSuccessful: data.code === ApiCode.SUCCESS, message: data.message }
      } catch (e) {
        handleCatch(e)
      }
      return null
    },
    async deleteDepartments({ commit }, id) {
      try {
        const response = await axios.delete(`uni/departments/${id}`)
        const { data } = response
        return { isSuccessful: data.code === ApiCode.SUCCESS, message: data.message }
      } catch (e) {
        handleCatch(e)
      }
      return null
    },
  },
}
